export default {
  data() {
    return {
      windowWidth: window.outerWidth,
      xsScreenWidth: 768
    }
  },
  computed: {
    desktopScreen() {
      return this.windowWidth >= this.xsScreenWidth
    }
  },
  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth
    }
  }
}